export default __webpack_public_path__ + "static/webhooks-create-preview-298988bf6f9533b625cca2cd0355b32a.png";